// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search_container {
  display: flex;
  background-color: var(--background-theme-color);
  width: 100%;
  height: 100%;
  justify-content: center;
}
.search_container_result_text_container {
  width: 90%;
}
.search_container_result_text {
  font-family: "Kufam";
  color: #fff;
  text-align: left;
  margin-top: 20px;
  margin-bottom: 20px;
}
.search_container_form_container {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}
.search_form {
  width: 70%;
}
.search_button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 25%;
  background-color: #00acee;
}
.search_text {
  padding-right: 5px;
}

.search_results_tab_contents .ant-tabs-tab-btn {
  font-size: 18;
}

.search_results_tab_contents
  .ant-tabs-tab.ant-tabs-tab-active
  .ant-tabs-tab-btn {
  color: #000000e0 !important;
}

.search_results_tab_contents .ant-tabs-tab .ant-tabs-tab-btn {
  color: #000000e0 !important;
}

.search_results_tab_contents .ant-tabs-nav::before {
}
.search_results_tab_container {
  display: flex;
  width: 100%;
  justify-content: center;
}
.search_results_tab_contents {
  width: 90%;
}
.tab_pane_inside_container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.search_results_container_trending_results {
  width: 100%;
}
.search_results_list_container_card {
  cursor: pointer;
  width: 90%;
  border-radius: 9px;
  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);
  display: flex;
  flex-direction: row;
  margin-bottom: 40px;
  overflow: hidden;
}
.search_results_list_container_card:hover > .image_hover_effect {
  transform: scale(1.05) !important;
  transition: var(--image-hover-transition);
}
.search_results_list_container_card .image_hover_effect {
  transition: var(--image-hover-transition);
}
.search_results_image {
  width: 50%;
  border-radius: 10px 0px 0px 10px;
  object-fit: cover;
}
.search_results_text_container {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 10px;
  padding-right: 5px;
}
.search_results_sub_title_container {
  line-height: 15px;
  width: 100%;
  padding-left: 5px;
  height: 80px;
  overflow: hidden;
  padding-top: 5px;
  padding-bottom: 5px;
}
.load_more_container {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.tab_container_trending_results {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.search_results_first_section {
  display: grid;
  grid-template-columns: 70% 30%;
  justify-content: center;
  width: 100%;
}

.trending_now_heading {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.trending_now_image {
  width: 40px;
  justify-content: center;
}
.trending_now_title {
  display: flex;
  align-items: center;
}
.trending_now_container {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
}
.trending_now_content {
  margin-top: 20px;
  padding: 10px;
}
.search_results_container_skeleton {
  display: flex;
  width: 100%;
}
.search_results_list_skeleton {
  display: grid;
  grid-template-columns: 100%;
  gap: 30px;
  margin-top: 10px;
  width: 100%;
}
.search_results_card {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  cursor: pointer;
  border-radius: 10px;
  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);
  position: relative;
}
.search_result_card_skeleton_width {
  width: 100%;
  margin: 10px;
  height: 200px;
}
.fact-check-list-news-story-card-skeleton {
  width: 650px !important;
  height: 250px !important;
  display: flex;
  margin-bottom: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout/search_results.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,+CAA+C;EAC/C,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;AACA;AACA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,oDAAoD;EACpD,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,UAAU;EACV,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,oDAAoD;EACpD,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".search_container {\n  display: flex;\n  background-color: var(--background-theme-color);\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n}\n.search_container_result_text_container {\n  width: 90%;\n}\n.search_container_result_text {\n  font-family: \"Kufam\";\n  color: #fff;\n  text-align: left;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.search_container_form_container {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n}\n.search_form {\n  width: 70%;\n}\n.search_button {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 25%;\n  background-color: #00acee;\n}\n.search_text {\n  padding-right: 5px;\n}\n\n.search_results_tab_contents .ant-tabs-tab-btn {\n  font-size: 18;\n}\n\n.search_results_tab_contents\n  .ant-tabs-tab.ant-tabs-tab-active\n  .ant-tabs-tab-btn {\n  color: #000000e0 !important;\n}\n\n.search_results_tab_contents .ant-tabs-tab .ant-tabs-tab-btn {\n  color: #000000e0 !important;\n}\n\n.search_results_tab_contents .ant-tabs-nav::before {\n}\n.search_results_tab_container {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n}\n.search_results_tab_contents {\n  width: 90%;\n}\n.tab_pane_inside_container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.search_results_container_trending_results {\n  width: 100%;\n}\n.search_results_list_container_card {\n  cursor: pointer;\n  width: 90%;\n  border-radius: 9px;\n  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 40px;\n  overflow: hidden;\n}\n.search_results_list_container_card:hover > .image_hover_effect {\n  transform: scale(1.05) !important;\n  transition: var(--image-hover-transition);\n}\n.search_results_list_container_card .image_hover_effect {\n  transition: var(--image-hover-transition);\n}\n.search_results_image {\n  width: 50%;\n  border-radius: 10px 0px 0px 10px;\n  object-fit: cover;\n}\n.search_results_text_container {\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding-left: 10px;\n  padding-right: 5px;\n}\n.search_results_sub_title_container {\n  line-height: 15px;\n  width: 100%;\n  padding-left: 5px;\n  height: 80px;\n  overflow: hidden;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n.load_more_container {\n  display: flex;\n  justify-content: center;\n  margin-top: 10px;\n}\n\n.tab_container_trending_results {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.search_results_first_section {\n  display: grid;\n  grid-template-columns: 70% 30%;\n  justify-content: center;\n  width: 100%;\n}\n\n.trending_now_heading {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n.trending_now_image {\n  width: 40px;\n  justify-content: center;\n}\n.trending_now_title {\n  display: flex;\n  align-items: center;\n}\n.trending_now_container {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex-direction: column;\n}\n.trending_now_content {\n  margin-top: 20px;\n  padding: 10px;\n}\n.search_results_container_skeleton {\n  display: flex;\n  width: 100%;\n}\n.search_results_list_skeleton {\n  display: grid;\n  grid-template-columns: 100%;\n  gap: 30px;\n  margin-top: 10px;\n  width: 100%;\n}\n.search_results_card {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  cursor: pointer;\n  border-radius: 10px;\n  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);\n  position: relative;\n}\n.search_result_card_skeleton_width {\n  width: 100%;\n  margin: 10px;\n  height: 200px;\n}\n.fact-check-list-news-story-card-skeleton {\n  width: 650px !important;\n  height: 250px !important;\n  display: flex;\n  margin-bottom: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
